import { Badge, Button, Col, Collapse, Form, Row } from 'antd';
import { useIntl } from 'react-intl';
import { FloatingFormItem } from '@/components/_common';
import { useDisclosure } from '@/hooks';
import CustomersSelectedModal from '@/components/_common/CustomersSelectedModal';
import { useState } from 'react';
import { FormInstance } from 'antd/es/form/Form';
import {
  QuestReportType,
  QuestWorkOrderReportFormValues,
} from '@/core/domain/questReport/Reports/WorkOrder/WorkOrder.types';
import VehiclesSelectedModal from '@/components/_common/VehiclesSelectedModal';
import { CustomerVehicleReduced } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import { Model } from '@/core/domain/people/BrandsModelsVersions/BrandsModelsVersions.types';
import EmployeesInfiniteSelectField from '@/components/_common/EmployeesInfiniteSelectField';
import InsurerInfiniteSelectField from '@/components/_common/InsurerInfiniteSelectField';
import BrandsModelsSelectedModal from '@/components/_common/BrandsModelsSelectedModal';
import SpaceForButton from '@/components/_common/SpaceForButtons';

import './style.less';
import BrandsInfiniteSelect from '@/components/_common/BrandsInfiniteSelect';
import TagsInfiniteSelectField from '@/components/_common/TagsInfiniteSelectField';
import StatusSelectField from '@/components/_common/StatusSelectField';

interface Props {
  form: FormInstance<QuestWorkOrderReportFormValues>;
}

const MoreOptionsWorkOderReport: React.FC<Props> = ({ form }) => {
  const { Panel } = Collapse;
  const intl = useIntl();
  const [openCustomer, setOpenCustomer] = useDisclosure(false);
  const [openVehicle, setOpenVehicle] = useDisclosure(false);
  const [openModels, setOpenModels] = useDisclosure(false);
  const [selectedCustomers, setSelectedCustomers] = useState<number[]>();
  const [selectedVehicles, setSelectedVehicles] =
    useState<CustomerVehicleReduced[]>();
  const [selectedBrands, setSelectedBrands] = useState<number[]>();
  const [selectedModels, setSelectedModels] = useState<Model[]>();

  const reportType = Form.useWatch('reportType', form);

  return (
    <Col span={24}>
      <Collapse accordion className="more-options-work-order-report">
        <Panel
          header={intl.formatMessage({
            id: 'movementWorkOrdersReport.form.moreOptions',
          })}
          key={1}
        >
          <Row gutter={[16, 16]}>
            <Col span={24} md={12}>
              <FloatingFormItem name="insurersIds" label="Seguradoras">
                <InsurerInfiniteSelectField allowClear mode="multiple" />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12}>
              <FloatingFormItem
                name="estimatorsIds"
                label={intl.formatMessage({
                  id: 'movementWorkOrdersReport.form.moreOptions.estimators',
                })}
              >
                <EmployeesInfiniteSelectField
                  mode="multiple"
                  queryFilter={{ estimator: true }}
                  allowClear
                />
              </FloatingFormItem>
            </Col>

            <Col span={24} md={12}>
              <FloatingFormItem label="Montadoras" name="brandsIds">
                <BrandsInfiniteSelect
                  allowClear
                  mode="multiple"
                  onChange={setSelectedBrands}
                />
              </FloatingFormItem>
            </Col>

            {reportType === QuestReportType.totalPerWorkOrder && (
              <>
                <Col span={24} md={12}>
                  <FloatingFormItem label="Etiquetas" name="tagsIds">
                    <TagsInfiniteSelectField />
                  </FloatingFormItem>
                </Col>

                <Col span={24} md={12}>
                  <FloatingFormItem label="Status" name="statusIds">
                    <StatusSelectField showSearch={false} />
                  </FloatingFormItem>
                </Col>
              </>
            )}

            <Col span={24}>
              <SpaceForButton>
                <Badge count={form.getFieldValue('customersIds')?.length}>
                  <Button block type="primary" onClick={setOpenCustomer.open}>
                    {intl.formatMessage({
                      id: 'movementWorkOrdersReport.form.moreOptions.button.selectCustomers',
                    })}
                  </Button>
                </Badge>

                <Badge count={form.getFieldValue('vehiclesIds')?.length}>
                  <Button block type="primary" onClick={setOpenVehicle.open}>
                    {intl.formatMessage({
                      id: 'movementWorkOrdersReport.form.moreOptions.button.selectVehicles',
                    })}
                  </Button>
                </Badge>

                <Badge count={form.getFieldValue('modelsIds')?.length}>
                  <Button block type="primary" onClick={setOpenModels.open}>
                    {intl.formatMessage({
                      id: 'movementWorkOrdersReport.form.moreOptions.button.selectModels',
                    })}
                  </Button>
                </Badge>
              </SpaceForButton>
            </Col>
          </Row>
        </Panel>
      </Collapse>

      <Form.Item name="customersIds" noStyle>
        <CustomersSelectedModal
          visible={openCustomer}
          handleVisible={setOpenCustomer.close}
          selectedCustomerIds={selectedCustomers}
          finishCallback={(customer) => {
            setSelectedCustomers(customer);
            form.setFieldValue('customersIds', customer);
          }}
        />
      </Form.Item>

      <Form.Item name="vehiclesIds" noStyle>
        <VehiclesSelectedModal
          visible={openVehicle}
          handleVisible={setOpenVehicle.close}
          selectedVehicle={selectedVehicles}
          finishCallback={(vehicle) => {
            setSelectedVehicles(vehicle);
            form.setFieldValue(
              'vehiclesIds',
              vehicle?.map(({ id }) => id),
            );
          }}
        />
      </Form.Item>

      <Form.Item name="modelsIds" noStyle>
        <BrandsModelsSelectedModal
          visible={openModels}
          handleVisible={setOpenModels.close}
          selectedBrandsModels={selectedModels}
          selectedBrandIds={selectedBrands}
          finishCallback={(models) => {
            setSelectedModels(models);
            form.setFieldValue(
              'modelsIds',
              models?.map(({ id }) => id),
            );
          }}
        />
      </Form.Item>
    </Col>
  );
};

export default MoreOptionsWorkOderReport;
